const useRole = (user) => {
	if (!user) {
		return null;
	}
	const { role } = typeof user === 'string' ? JSON.parse(user) : user;
	return role?.name;
};

export const checkRole = (user, { name, id }) => {
	if (!user) {
		return null;
	}
	const { role } = typeof user === 'string' ? JSON.parse(user) : user;

	if (name) {
		return role?.name === name;
	}
	if (id) {
		return role?.id === id;
	}
	return false;
};

export default useRole;
